'use client';

import { Plans } from './components';
import type { StripeProduct } from '@/lib/stripe-products';

interface AccountPlansContentProps {
  stripeProducts: StripeProduct[];
}

export function AccountPlansContent({
  stripeProducts,
}: AccountPlansContentProps) {
  return <Plans stripeProducts={stripeProducts} />;
}
